// extracted by mini-css-extract-plugin
export var team = "Team-module--team--Pc82E";
export var team__mapContainer = "Team-module--team__mapContainer--UWoNY";
export var team__list = "Team-module--team__list--8S3KE";
export var team__item = "Team-module--team__item--Q2qZE";
export var team__itemCount = "Team-module--team__itemCount--pCGyo";
export var team__itemText = "Team-module--team__itemText--2Tbi9";